import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { qrCode } from '../../redux/slice/QRCode';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import Loader from '../../components/loader/Loader';
import { toast } from 'react-toastify';

export default function QRCode(props) {
    const { show, setShow, linkData } = props
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)
    const qrCodeImage = useSelector((state) => state.qrCode.data?.[0])

    useEffect(() => {
        if (!show || !linkData?.short_code) return
        setLoading(true)
        const url = linkData?.plan_type === 'free' ? 'https://ad1.free/' : 'https://ad1.now/'
        dispatch(qrCode({ short_url: `${url}o/${linkData.short_code}`, navigate })).finally(() => setLoading(false))
    }, [show, linkData])

    const handleDownload = async () => {
        if (!qrCodeImage?.qr_code_url) {
            toast.error('QR code image not available');
            return;
        }

        try {
            const response = await fetch(qrCodeImage.qr_code_url);
            if (!response.ok) {
                throw new Error('Failed to fetch QR code image');
            }
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `qrcode-${linkData?.short_code || 'qr'}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            toast.success('QR code downloaded successfully!', { position: "bottom-right" });
        } catch (error) {
            console.error('Error downloading QR code:', error);
            toast.error('Failed to download QR code. Please try again.', { position: "bottom-right" });
        }
    };

    return (
        <>

            <Modal
                size="md"
                show={show}
                centered
                onHide={() => setShow(false)}
                aria-labelledby="example-modal-sizes-title-md"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-modal-sizes-title-md">
                        QR Code
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        loading ?
                            <Loader />
                            :
                            <div className='text-center'>
                                <img
                                    src={qrCodeImage?.qr_code_url}
                                    alt="QR Code"
                                    style={{ width: 300, height: 300 }}
                                />
                                <button
                                    style={{ width: '100%', marginTop: '15px' }}
                                    className='btn btn-secondary'
                                    onClick={handleDownload}
                                    disabled={!qrCodeImage?.qr_code_url}
                                >
                                    DOWNLOAD
                                </button>
                            </div>
                    }
                </Modal.Body>
            </Modal>
        </>
    )
}
